import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
  name: 'searchOrder'
} )
export class OrdersSearchPipe implements PipeTransform {
  transform ( items: any[], searchText: string ) {
    if ( !items ) { return []; }
    if ( !searchText ) { return items; }
    searchText = searchText.toLowerCase();

    return items.filter( item => {
      return item.destAddress.some( ( obj ) => {
        return (!!~obj.city.indexOf( searchText )) || (!!~obj.street.indexOf( searchText ));
      } ) || (!!~item.startAddress.city.indexOf( searchText )) || (!!~item.startAddress.street.indexOf( searchText ));
    } );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/pipe/orders-search.pipe.ts